import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';
import type {
  SendConversationalMessageInput,
  ConversationalResponsePayload,
} from '../types';

export const conversationalService = {
  /**
   * Envia uma mensagem em linguagem natural para o OpsCopilot / AI Gateway.
   */
  async sendMessage(input: SendConversationalMessageInput): Promise<ConversationalResponsePayload> {
    const fn = httpsCallable<SendConversationalMessageInput, ConversationalResponsePayload>(
      functions,
      'sendConversationalMessage'
    );
    const res = await fn(input);
    return res.data;
  },

  /**
   * Reseta a sessão conversacional ativa e limpa o contexto de memória efêmera.
   */
  async resetSession(tenantId: string, conversationId: string): Promise<boolean> {
    const fn = httpsCallable<{ tenantId: string; conversationId: string }, { success: boolean }>(
      functions,
      'resetConversationalSession'
    );
    const res = await fn({ tenantId, conversationId });
    return res.data.success;
  },
};
